import * as firebase from "firebase";

var config = {
    apiKey: "AIzaSyCt1sjvisaHU1-96RV-UyC1ESKvhL0OaIc",
    authDomain: "jigao-4f2c1.firebaseapp.com",
    databaseURL: "https://jigao-4f2c1.firebaseio.com",
    projectId: "jigao-4f2c1",
    storageBucket: "jigao-4f2c1.appspot.com",
    messagingSenderId: "364731289748",
    appId: "1:364731289748:web:3525221d474471c2b8e481",
    measurementId: "G-L9L9C9VYX6"
};

firebase.initializeApp(config);

export default firebase;